import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/videos/little-star-dude.webm")